import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/home/home.vue';

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home1',
      component: Home,
      meta: {
        access: {
          withoutAuth: true, //全部开放
        },
      },
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        access: {
          withoutAuth: true, //全部开放
        },
      },
    },
    {
      path: '/403',
      meta: {
        access: {
          withoutAuth: true, //全部开放
        },
      },
      name: '403',
      component: resolve => require(['./views/error/403'], resolve),
    },
    { // 到期提醒
      path: '/expiration-reminder',
      name: 'expirationReminder',
      component: resolve => require(['./views/tips/expiration-reminder.vue'], resolve),
      meta: {
        access: {
          withoutAuth: true, //全部开放
        },
      },
    },
    {
      path: '*',
      name: '404',
      component: resolve => require(['./views/error/404'], resolve),
      meta: {
        access: {
          withoutAuth: true, //全部开放
        },
      },
    },
  ],
});
/**
 * 路由拦截处理
 */
router.beforeEach((to, from, next) => {
  // eslint-disable-next-line no-undef
  if (ccutils && ccutils.setHomeFlag) {
    // eslint-disable-next-line no-undef
    ccutils.setHomeFlag();
  }
  next();
});
export default router;
